export enum DealMarketStatus {
  All = 'View All',
  Completed = 'Completed',
  Expected = 'Expected',
  InMarket = 'In Market',
  Hung = 'Hung',
}

export enum SecurityType {
  BOND = 'bond',
  LOAN = 'loan',
  COMBINED = 'combined',
}

export enum ModerationStatus {
  DRAFT = 'draft',
  HOLD = 'hold',
  PUBLISHED = 'published',
  REMOVE = 'remove',
  SENT = 'sent',
  UNPUBLISHED = 'unpublished',
}
